import React from "react";
import TitlePages from "../../components/TitlePage";
import { motion } from "framer-motion";
import CTAsec from "../../components/CTAsec";
import Casos from "./Casos";

const Exito = ({ variants }) => {
  return (
    <>
      <motion.div
        className={"transition"}
        initial={{ x: 0 }}
        animate={{ x: "100%" }}
        exit={{ x: 0 }}
        transition={{
          transition: 3,
          type: "spring",
          stiffness: 200,
        }}
      />
      <div className="containerDiv">
        <TitlePages
          title={"Nuestros casos de éxito"}
          toptitle={"Éxito"}
          variants={variants}
        />
        <Casos />
        <CTAsec href={"/contacto"} type="link" variants={variants} />
      </div>
    </>
  );
};

export default Exito;
